export const EMPTY_TOKEN = 'Hãy nhập code nhé. Nếu không có hãy liên hệ Zalo bên dưới Footer nhé'
export const LOGIN_AUTO_ERR = 'Code không đúng hoặc đã hết hạn. Hãy liên hệ Zalo bên dưới Footer nhé'
export const LOGIN_AUTO_EXCEPTION = 'Đã có lỗi xảy ra. Hãy liên hệ Zalo bên dưới Footer nhé'
export const COOKIE_ERR = 'Cookie đã hết hạn hoặc không khả dụng, hãy lấy thử lấy cookie lại một lần nữa'
export const EMPTY_COOKIE = 'Hãy tham khảo video bên dưới để lấy cookie nhé'
export const LOGIN_FAILED = 'Đăng nhập thất bại. Hãy kiểm tra lại username và password'
export const CONFIG_PLAYER_SUCCESS = "Lưu thiết lập thành công"
export const CONFIG_PLAYER_ERROR = "Không thể lưu thiết lập. Xin hãy thử lại sau"
export const DANG_CAN_QUET = "Đang Càn quét hải sản"
export const DONE_CAN_QUET = "Càn quét hải sản thành công"
export const UPDATING_SETTING = "Đang cập nhật cài đặt"
export const DONE_UPDATE_SETTING = "Cập nhật cài đặt thành công"
export const ERROR_UPDATE_SETTING = "Cập nhật cài đặt đã xãy ra lỗi. Hãy thử lại sau"
export const NO_UPDATE_SETTING = "Cài đặt không thay đổi"
export const GETTING_SETTING = "Đang lấy thông tin cài đặt"
export const DONE_GET_SETTING = "Lấy thông tin cài đặt thành công"
export const ERROR_GET_SETTING = "Lấy thông tin cài đặt đã xãy ra lỗi. Hãy thử lại sau"
export const STOPPING_PLAYER = "Đang stop game"
export const STOPPED_PLAYER = "Đã stop game"
export const ERROR_STOP_PLAYER = "Không thể stop game. Hãy login vào game từ wjh5 để stop game"
export const STARTING_PLAYER = "Đang khởi động game"
export const STARTED_PLAYER = "Đã chạy game"
export const ERROR_START_PLAYER = "Không thể chạy game. Hãy thử clear cookie và đăng nhập lại"
export const GETTING_COOKIE = "Đang thực hiện lấy cookie"
export const GETTED_COOKIE = "Đã lấy cookie thành công"
export const ERROT_GET_COOKIE = "Lấy cookie thất bại. Hãy kiểm tra lại thông tin đăng nhập"
export const OUT_OF_TIME_QC = "Chưa đến thời gian diễn ra Quốc Chiến. Hãy thử lại sau"
export const CODE_EXPIRED = "Code đã hết hạn. Xin vui lòng liên hệ admin"
export const DONE_QUOC_CHIEN = "Kết thúc Quốc Chiến"
export const DANG_QUOC_CHIEN = "Đang auto Quốc Chiến"
export const START_SELL_EQUIPMENT = "Bắt đầu bán trang bị"
export const ERROR_START_SELL_EQUIPMENT = "Có lỗi xãy ra. Không thể bán trang bị"
export const DANG_SELL_EQUIPMENT = "Đang bán "
export const NO_SELL_EQUIPMENT = "Không có trang bị đang chọn để bán"
export const DONE_SELL_EQUIPMENT = "Đã bán xong trang bị"
export const ERROR_START_TRUC_LOC = "Đã có lỗi xảy ra. Xin vui lòng thử lại"
export const ERROR_TRUC_LOC_LIMIT_LEVEL = "Để ghép trục lộc cần đạt Level "
export const ERROR_TRUC_LOC_LIMIT_TIME = "Ghép trục lộc trong khoản thời gian 10h00 ~ 22h00"
export const START_AUTO_TRUC_LOC = "Bắt đầu ghép trận đấu"
export const RUNING_AUTO_TRUC_LOC = "Trục Lộc: "
export const DONE_AUTO_TRUC_LOC = "Đã xong Trục Lộc"
